import { Box } from "@material-ui/core";
import { ActivatedPinIcon } from "../../../../assets/icons/icon";
import { ParagraphText, UBButton } from "../../../../Libraries";
import { useContext } from "react";
import { LanguageContext } from "../../../../context/LanguageContext";
import styles from "./styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const ActivatedPinCode = ({ handleChangePIN }) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <Box className={styles.ActivatedPinCodeContainer}>
      <Box className={styles.activatedPinIconWrap} aria-hidden="true">
        <ActivatedPinIcon width="60px" height="60px" />
      </Box>

      <Box className={styles.headingContainer}>
        <ParagraphText
          className={`fontWeight500 fontSize24 newFontColor ${styles.heading}`}
        >
          {I18n.pin}
        </ParagraphText>

        <ParagraphText
          className={`fontSize14 fontWeight400 newLightColor ${styles.activatedPinSubtitle}`}
        >
          {I18n.it_ensure_that_no_one_else_can_access}
        </ParagraphText>
      </Box>

      <Box className={styles.activatedPinCTA}>
        <UBButton
          id="change_pin_btn"
          onClick={() => {
            triggerLogEvent(analytics, "setting_pin_activated");
            handleChangePIN();
          }}
          title={I18n.change_pin}
          className={`ubPrimaryButton fontSize14 fontWeight400 textUppercase ${styles.activatedPinChangeBtn}`}
        />
      </Box>
    </Box>
  );
};

export default ActivatedPinCode;
